import { apiClient } from "./ApiClient";

export async function fetchUsersAdmin({ skip, limit, sort_by, sort_order, filters }) {
  const params = new URLSearchParams({ skip, limit, sort_by, sort_order });

  for (const key in filters) {
    if (filters[key] !== null && filters[key] !== "") {
      params.append(key, filters[key]);
    }
  }

  const response = await apiClient.get(`/user/admin/batch?${params}`);
  return response.data;
}

export async function updateUser({ userData }) {
  const response = await apiClient.put("/user/update", userData);
  return response.data;
}

export async function deleteUser({ email }) {
  const response = await apiClient.delete(`/user/${encodeURIComponent(email)}`);
  return response.data;
}

export const markNewsletter = async (email, subscribe) => {
  const { data } = await apiClient.patch(`/user/${encodeURIComponent(email)}/newsletter`, { subscribe });
  return data;
};

export const setupAppTwoFactor = async () => {
  const { data } = await apiClient.post("/user/2fa/app/setup", null, {
    responseType: "blob",
  });
  return data;
};

export const enableAppTwoFactor = async (code) => {
  const { data } = await apiClient.post("/user/2fa/app/enable", null, {
    params: { code },
  });
  return data;
};

export const enableEmailTwoFactor = async () => {
  const { data } = await apiClient.post("/user/2fa/email/enable");
  return data;
};

export const disableAppTwoFactor = async (code) => {
  const { data } = await apiClient.post("/user/2fa/app/disable", null, {
    params: { code },
  });
  return data;
};

export const requestDisableEmailTwoFactor = async () => {
  const { data } = await apiClient.post("/user/2fa/email/disable-request");
  return data;
};

export const disableEmailTwoFactor = async (code) => {
  const { data } = await apiClient.post("/user/2fa/email/disable", null, {
    params: { code },
  });
  return data;
};
